import { buildOrganizationSchema, getSchemaLogoUrl, SCHEMA_IDS, SCHEMA_SITE_ROOT } from './organization.js';
import { buildWebsiteSchema } from './website.js';

/**
 * Homepage @graph — Organization → WebSite → WebPage (SEO team specification).
 * @param {{ pageTitle: string, description: string, logoUrl?: string }} params
 */
export function buildHomepageSchema({ pageTitle, description, logoUrl = getSchemaLogoUrl() }) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      buildOrganizationSchema({ description, logoUrl }),
      buildWebsiteSchema(),
      {
        '@type': 'WebPage',
        '@id': SCHEMA_IDS.homepage,
        url: SCHEMA_SITE_ROOT,
        name: pageTitle,
        description,
        isPartOf: {
          '@id': SCHEMA_IDS.website,
        },
        about: {
          '@id': SCHEMA_IDS.organization,
        },
        mainEntity: {
          '@id': SCHEMA_IDS.organization,
        },
        primaryImageOfPage: {
          '@id': SCHEMA_IDS.logo,
        },
        inLanguage: 'en-IN',
      },
    ],
  };
}
